document.addEventListener("DOMContentLoaded", function () {
    // Target: 20 Aug 2026, 12:00 AM
    const targetDate = new Date(2026, 7, 20, 0, 0, 0); // month is 0-indexed, so 7 = August

    function getTimeUntilTarget() {
        const now = new Date();
        return targetDate - now;
    }

    function startCountdown() {
        const timerElement = document.getElementById("countdown-timer"); // wrap your timer in an element with this id

        function updateCountdown() {
            const timeLeft = getTimeUntilTarget();

            if (timeLeft <= 0) {
                clearInterval(interval);
                if (timerElement) {
                    timerElement.style.display = "none";
                }
                return;
            }

            const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
            const seconds = Math.floor((timeLeft / 1000) % 60);
            const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

            const daysEl = document.getElementById("days");
            if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
            document.getElementById("hours").textContent = String(hours).padStart(2, '0');
            document.getElementById("minutes").textContent = String(minutes).padStart(2, '0');
            document.getElementById("seconds").textContent = String(seconds).padStart(2, '0');
        }

        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);
    }

    startCountdown();
});
